export default __webpack_public_path__ + "static/media/nodeC.04132dc7.webp";